import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { momentConverter } from '../value-converter';
import { FilterControl, FilterControlComponent } from './filter-control';

@Component({
  template: `
    <glxy-form-field [formGroup]="formGroup" [bottomSpacing]="'none'" [size]="'small'">
      <glxy-label>{{ control.label | translate }}</glxy-label>

      <input
        matInput
        placeholder="{{ control.label | translate }}"
        [matDatepicker]="datePicker"
        [formControl]="control"
      />
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>

      <glxy-hint *ngIf="control.hint">{{ control.hint | translate }}</glxy-hint>
    </glxy-form-field>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterControlComponent implements FilterControlComponent {
  control: DateFilterControl;
  formGroup: UntypedFormGroup;
}

export class DateFilterControl extends FilterControl {
  component = DateFilterControlComponent;
  converter = momentConverter;
}
